<forge-select [disabled]="isViewOnly" [name]="Name" attr.telemetry="Submission-{{Label}}" [value]="selected"
              [selectOnBlur]="selectOnBlur" [required]="isRequired && !forCellEdit" (change)="fireValueChanged($event)"
              [invalid]="isInvalid" [(ngModel)]="selected" focusOnLoad [forCellEdit]="forCellEdit"
              [propertyMetadata]="propertyMetadata" [id]="controlId" [density]="Density" (focus)="onFocus()"
              [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" (keydown)="onKeyDown($event)"
              [attr.label-position]="LabelPosition" [label]="Label" [aria-label]="Label" [attr.shape]="forCellEdit ? 'squared' : null">
    <forge-option *ngFor="let item of options" [value]="item.Key">
        {{item.Value}}
    </forge-option>
    <span *ngIf="hint && !dense && !compact" slot="support-text">{{hint}}</span>
    <span *ngIf="error && !dense && !compact" slot="support-text" class="error-red">{{error}}</span>
    <forge-circular-progress *ngIf="showSpinner" slot="end" class="metadata-input--spinner">
    </forge-circular-progress>
</forge-select>